<template>
    <div>Admin</div>
</template>

<script>
    export default {
        name: string = 'Admin',
    };
</script>

<style scoped>

</style>
